import { log } from 'console'
import BaseApi from '../base/base'

export default class CartApi extends BaseApi {
  constructor() {
    super()
    this.path = '/carts/cart_counter'
  }

  /**
   * Get the number of items in cart
   * @returns Promise with the cart item count
   */
  async getCartItemCount(): Promise<number> {
    try {
      const originalPath = this.path
      const response = await this.getRequest()
      this.path = originalPath

      if (response.data && response.data.itemNumbers) {
        return response.data.itemNumbers
      }
      return 0
    } catch (error) {
      console.error('Error fetching cart count:', error)
      return 0
    }
  }
}
